import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { sanitizeDialogSearch } from "@/lib/use-dialog-search";
import { appRoute } from "./route";

const RecurringPage = lazy(async () => {
  const m = await import("@/features/recurring/components/recurring-page");
  return { default: m.RecurringPage };
});

function RecurringPageWrapper() {
  return (
    <Suspense fallback={null}>
      <RecurringPage />
    </Suspense>
  );
}

export const recurringRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/recurring",
  // Addressable create/edit dialogs: `?new=1` / `?edit=<ruleId>`.
  validateSearch: sanitizeDialogSearch,
  component: RecurringPageWrapper,
});
